import { render, staticRenderFns } from "./ListLocations.vue?vue&type=template&id=2c72ecbb&scoped=true&"
import script from "./ListLocations.vue?vue&type=script&lang=ts&"
export * from "./ListLocations.vue?vue&type=script&lang=ts&"
import style0 from "./ListLocations.vue?vue&type=style&index=0&id=2c72ecbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c72ecbb",
  null
  
)

export default component.exports